<template>
  <div>
    <div class="container-fluid py-3 height-100">
      <modal-menu :menus="menus" :selected="menu" @changeMenu="(m) => {this.menu = m}" v-if="menus[1].active"/>
      <div v-if="dados.nome_cozinha" v-show="menu === 1">
        <div class="mb-3 d-none" v-if="dados.id_cozinha">
          <h6>Monitor KDS</h6>
          <a :href="`${base_gestor}monitor?cozinha=${dados.id_cozinha}`" target="_blank">{{`${base_gestor}monitor?cozinha=${dados.id_cozinha}`}}</a>
          <p class="mb-2 small">
            O <b>Monitor KDS</b> elimina o uso de impressora na cozinha com o uso de tablets ou dispositivos de fila de produção dos seus pedidos.
          </p>
          <div>
            <a href="javascript:" class="text-danger" @click="copyLink(`${base_gestor}monitor?cozinha=${dados.id_cozinha}`)"><i class="fa fa-copy"></i> Copiar Link</a>
          </div>
          <hr>
        </div>
        <div class="row no-gutters">
          <div class="col-6 p-1">
            <label class="mb-0">Nome</label>
            <input type="text" class="form-control" v-model="dados.nome_cozinha" required>
          </div>
          <div class="col-6 p-1" v-if="isElectron">
            <label class="mb-0">Impressora</label>
            <select class="form-control" v-model="dados.device">
              <option :value="null">Impressora do Sistema</option>
              <option :value="p.displayName" v-for="p in printers">{{p.name + (p.isDefault ? ' (Padrão)' : '')}}</option>
            </select>
            <div class="small text-danger" v-show="dados.device && !printers.find(p => p.displayName === dados.device)">Impressora {{dados.device}} não encontrada</div>
          </div>
          <div class="col-6 p-1" @click="() => $swal('Para alterar a impressora acesse o gestor local de pedidos')" v-else>
            <label class="mb-0">Impressora</label>
            <div class="form-control bg-light">{{dados.device || 'Padrão do computador'}}</div>
          </div>
        </div>
        <hr>
        <div class="px-1">
          <div class="d-none">
            <label class="mb-0">
              <input type="radio" value="1" name="imprimir" v-model="dados.imprimir"/> Imprimir e exibir no monitor de pedidos
            </label>
            <br>
            <label class="mb-0">
              <input type="radio" value="2" name="imprimir" v-model="dados.imprimir"/> Exibir no monitor de pedidos (não imprimir)
            </label>
          </div>
          <label class="mb-0">
            <input type="checkbox" @change="dados.print_delivery = dados.print_delivery === '1' ? '0' : '1'" :checked="dados.print_delivery === '1'" />
            Imprimir Delivery e Retiradas
          </label>
        </div>
      </div>
      <div v-show="menu === 2">
        <h6 class="text-center mb-2">Selecione as categorias</h6>
        <div class="alert alert-warning small">
          <i class="fa fa-exclamation-triangle"></i> Atenção! Ao editar esta Cozinha, as configurações salvas nos produtos serão substituídas.
        </div>
        <div class="mb-1" v-for="c in categorias">
          <label>
            <input type="checkbox" class="mr-2" :value="c.id_categoria" v-model="dados.categorias"> {{c.nome_categoria}}
          </label>
        </div>
      </div>
    </div>
    <div class="border-top p-2 text-center d-flex justify-content-between">
      <div class="d-flex justify-content-between w-100">
        <button class="btn btn-light border p-3 " @click="$emit('fechar')"><i class="fa fa-angle-left"></i> Voltar</button>
        <button class="btn btn-success px-4 p-3" @click="salvarCozinha">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalMenu from "@/components/commons/ModalMenu";
  export default {
    name: "ProdutosCozinha",
    components: {ModalMenu},
    props: ['printers'],

    data() {
      return {
        token: localStorage.getItem('key'),
        load: true,
        base_gestor: '',
        categorias: [],
        dados: {},
        menus: [
          { nome: 'Dados', active: true },
          { nome: 'Produtos', active: true }
        ],
        menu: 1,
      }
    },

    methods: {
      buscarCategorias() {
        if (this.categorias.length) {
          return;
        }

        this.$http.get('categorias/' + this.token)
          .then(response => {
            this.load = false;
            this.categorias = response.data;

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          })
      },

      salvarCozinha() {
        if (!this.dados.nome_cozinha.trim()) {
          this.$swal("O nome da cozinha não pode ficar em branco!");
          return;
        }

        if (this.isElectron && this.dados.device && !this.printers.find(p => p.displayName === this.dados.device)) {
          this.$swal("A impressora selecionada não está instalada neste computador! Por favor altere antes de salvar.");
          return;
        }

        this.load = true;
        this.$http.post('cozinhas/' + this.token, this.dados)
          .then(response => {
            this.$swal(!this.dados.id_cozinha ? "Cozinha cadastrada com sucesso!" : "Cozinha editada com sucesso!" );
            this.$emit('salvar');
            this.load = false;

          }, res => {
            this.load = false;
            this.$swal(res.data.msg);
          });
      },

      copyLink(text) {
        navigator.clipboard.writeText(text);
      }
    },

    mounted() {
      const isHomolog = window.location.href.startsWith('https://hhh.');
      this.base_gestor = isHomolog ? `https://hhh.gestor.lecard.delivery/` : `https://gestor.lecard.delivery/`;
    },

    created() {
      this.$parent.$on('loadDadosModal', (cozinha) => {
        this.menu = 1;

        if (cozinha) {
          this.buscarCategorias();
          this.dados = {
            id_cozinha: cozinha.id_cozinha || null,
            nome_cozinha: cozinha.nome_cozinha,
            imprimir: cozinha.imprimir,
            print_delivery: cozinha.print_delivery,
            device: cozinha.device,
            categorias: cozinha.categorias || [],
            fg_ativo: cozinha.fg_ativo
          };
        }
      });
    }
  }
</script>
<style scoped>
</style>
